import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck } from '@fortawesome/pro-solid-svg-icons';

// utils
import { getSection, isRequired } from '../../../../../utils/form';

function IndicatorIcon({ sectionComplete, className }) {
  const { touchedSubmitPage } = useSelector(store => store);
  const SUCCESS = 'var(--bs-success)';
  const GRAY = 'var(--bs-gray-400)';
  const RED = 'var(--bs-danger)';

  let iconColor = GRAY;
  let icon = faCheck;

  if (sectionComplete) {
    iconColor = SUCCESS;
  } else if (touchedSubmitPage) {
    iconColor = RED;
    icon = faXmark;
  }

  return (
    <FontAwesomeIcon
      color={iconColor}
      icon={icon}
      className={className}
    />
  );
}

function NavItem({ section, page, currentPath }) {
  const navigate = useNavigate();
  const { baseRoute, form } = useSelector(store => store.form);
  const { values: currentValues, valid } = useSelector(store => store);
  const itemLocation = `/enroll${baseRoute}${section.route}${page.route}`;

  // if there are any required fields on the page, mark it with a red asterisk
  const required = page.fields.find(field => (
    isRequired({ name: field.name, form, currentValues })
  ));

  const active = (itemLocation === currentPath) ? 'fw-bold' : 'text-muted';

  let sectionComplete = true;
  page.fields.forEach(({ name }) => {
    // check if all required fields are valid
    const r = isRequired({ name, form, currentValues }); // if field is required
    const v = valid[name]; // if field is currently valid
    if (r && !v) sectionComplete = false;
    // check for non required fields that are invalid
    if (!r && (v === false)) sectionComplete = false;
  });

  return (
    <div
      role="button"
      tabIndex={0}
      className="row mb-3 align-items-center"
      onClick={() => navigate(itemLocation)}
    >
      <IndicatorIcon className="w-auto" sectionComplete={sectionComplete} />
      <div className={['text-decoration-underline w-auto px-0', active].join(' ')}>
        {page.title}
      </div>
      {required && (<span className="w-auto text-danger">*</span>)}
    </div>
  );
}

function SideNav() {
  const location = useLocation();
  const section = getSection(location);

  return (
    <>
      {section.pages.map(page => (
        <NavItem key={page.route} section={section} page={page} currentPath={location.pathname} />
      ))}
    </>
  );
}

export default SideNav;
